module.exports = __webpack_public_path__ + "static/media/3.25a6afa1.webp";